import { render, staticRenderFns } from "./TeacherStudentModal.vue?vue&type=template&id=11b21c8a&"
import script from "./TeacherStudentModal.vue?vue&type=script&lang=ts&"
export * from "./TeacherStudentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports